// react
// dependencies
import React, { useRef, useState } from "react";

// components
import ComponentLoader from "../../../../../../../components/Spinner/ComponentLoader";

// types
import { Goal } from "../../../../../../../api/services/searchServiceResultTypes/goal";

import GoalCard from "../../../../../Common/GoalCard";
// styles
import css from "./Style.module.scss";

type TopLevelGoalsProps = {
	changeActiveGoal: (goal) => void;
	topLevelGoals: Array<Goal>;
	isLoading: boolean;
	preChangeActiveGoal?: () => void;
};

export const TopLevelGoals = ({
	changeActiveGoal,
	topLevelGoals = [],
	isLoading = false,
	preChangeActiveGoal = () => {},
}: TopLevelGoalsProps) => {
	const [isAnimatingGoalID, setIsAnimatingGoalID] = useState();

	const handleGoalClick = (goal) => {
		preChangeActiveGoal();
		setIsAnimatingGoalID(goal._id);

		setTimeout(() => {
			changeActiveGoal(goal);
		}, 400);
	};

	const grid = useRef(null);

	if (isLoading) {
		return <ComponentLoader />;
	}

	const activeGoal = topLevelGoals.find((goal) => goal._id === isAnimatingGoalID);

	return (
		<div className={css.Main} data-testid="topLevelGoals">
			<div>
				{activeGoal && (
					<GoalCard
						key={`card-${activeGoal._id}`}
						isActive={true}
						className={` ${css.topLevelGoal} ${css.isActiveGoal} `}
						onClick={handleGoalClick}
						goal={activeGoal}
					/>
				)}
			</div>
			<div className={css.List} ref={grid}>
				{topLevelGoals.map((goal) => {
					return (
						<div key={`goal-card-${goal._id}`} className={`${css.goalCard}`}>
							<GoalCard
								key={`card-${goal._id}`}
								isActive={false}
								className={` ${css.topLevelGoal} ${isAnimatingGoalID && css.isInactiveLeavingGoal} `}
								onClick={handleGoalClick}
								goal={goal}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default TopLevelGoals;
